/* Production Site */
export const PRODUCTION_HOST = 'https://www.refinery29.com';

/* Nginx routing layer */
export const ARCHIVES_ROUTE_TYPE = 'passthrough';
export const ARTICLE_ROUTE_TYPE = 'blog_entry';
export const CHANNEL_ROUTE_TYPE = 'aggregation';
export const CONTRIBUTOR_ROUTE_TYPE = 'contributor';
export const PRODUCT_LIST_ROUTE_TYPE = 'shops_categories';
export const PRODUCT_BRAND_ROUTE_TYPE = 'shops_brand';
export const PRODUCT_RETAILER_ROUTE_TYPE = 'shops_retailer';
export const SEARCH_ROUTE_TYPE = 'search';
export const SHOPPING_ROUTE_TYPE = 'shops_product';
export const STATIC_ROUTE_TYPE = 'blog_static';

/* Bridge and Foundry */
export const ARCHIVES_PAGE_TYPE = 'archives';
export const ARTICLE_FULL_WIDTH_PAGE_TYPE = 'entry.article-full-width';
export const ARTICLE_RIGHT_RAIL_PAGE_TYPE = 'entry.article';
export const ARTICLE_SLIDESHOW_PAGE_TYPE = 'entry.slideshow';
export const POST_ARTICLE_SLIDESHOW_PAGE_TYPE = 'entry.slideshow';
export const ARTICLE_CUSTOM_PAGE_TYPE = 'entry.custom';
export const CHANNEL_PAGE_TYPE = 'aggregation';
export const CONTRIBUTOR_PAGE_TYPE = 'contributors';
export const SEARCH_PAGE_TYPE = 'search';
export const PRODUCT_DETAIL_PAGE_TYPE = 'product_detail';
export const PRODUCT_LIST_PAGE_TYPE = 'product_list';
export const STATIC_PAGE_TYPE = 'static';
export const VIDEO_SERIES_PAGE_TYPE = 'entry.series-video';

export const US_HOMEPAGE_ID = 36;
export const US_WATCH_HOME_ID = 1155;
export const UK_WATCH_HOME_ID = 1156;
export const DE_WATCH_HOME_ID = 1157;
export const WATCH_HOME_IDS = [
  US_WATCH_HOME_ID,
  UK_WATCH_HOME_ID,
  DE_WATCH_HOME_ID
];

/* Editions */
export const EDITION_BASENAME_EN_US = 'en-us';
export const EDITION_BASENAME_EN_GB = 'en-gb';
export const EDITION_BASENAME_DE_DE = 'de-de';
export const EDITION_BASENAME_FR_FR = 'fr-fr';
export const EDITION_BASENAME_EN_CA = 'en-ca';
export const EDITION_BASENAME_EN_AU = 'en-au';

export const EDITION_ID_EN_US = 1;
export const EDITION_ID_EN_GB = 2;
export const EDITION_ID_DE_DE = 3;
export const EDITION_ID_FR_FR = 4;
export const EDITION_ID_EN_CA = 5;
export const EDITION_ID_EN_AU = 6;

export const VALID_EDITION_BASENAMES = [
  EDITION_BASENAME_EN_US,
  EDITION_BASENAME_EN_GB,
  EDITION_BASENAME_DE_DE,
  EDITION_BASENAME_FR_FR,
  EDITION_BASENAME_EN_CA,
  EDITION_BASENAME_EN_AU
];

export const ENGLISH_EDITION_IDS = [
  EDITION_ID_EN_US,
  EDITION_ID_EN_GB,
  EDITION_ID_EN_CA,
  EDITION_ID_EN_AU
];

export const DRAFT_EDITION_IDS = [];

/* Geolocation */
export const GEOLOCATION_US = 'us';
export const GEOLOCATION_UK = 'uk';
export const GEOLOCATION_DE = 'de';
export const GEOLOCATION_FR = 'fr';
export const GEOLOCATION_CA = 'ca';
export const GEOLOCATION_AU = 'au';

export const EDITION_ID_TO_GEOLOCATION = {
  [EDITION_ID_EN_US]: GEOLOCATION_US,
  [EDITION_ID_EN_GB]: GEOLOCATION_UK,
  [EDITION_ID_DE_DE]: GEOLOCATION_DE,
  [EDITION_ID_FR_FR]: GEOLOCATION_FR,
  [EDITION_ID_EN_CA]: GEOLOCATION_CA,
  [EDITION_ID_EN_AU]: GEOLOCATION_AU
};

export const editionTagID = {
  [EDITION_ID_EN_US]: 'enUS',
  [EDITION_ID_DE_DE]: 'deDE',
  [EDITION_ID_EN_GB]: 'enGB',
  [EDITION_ID_FR_FR]: 'frFR',
  [EDITION_ID_EN_CA]: 'enCA',
  [EDITION_ID_EN_AU]: 'enAU'
};
export const editionTagClass = {
  [EDITION_ID_EN_US]: 'en',
  [EDITION_ID_DE_DE]: 'de',
  [EDITION_ID_EN_GB]: 'en',
  [EDITION_ID_FR_FR]: 'fr',
  [EDITION_ID_EN_CA]: 'en',
  [EDITION_ID_EN_AU]: 'en'
};

export const EDITION_PINTEREST_VERIFY = {
  [EDITION_ID_EN_US]: 'b10faeb45f92f5ebf0073a215d615ea9',
  [EDITION_ID_EN_GB]: '824df583bae44d08b2de179a271364fd'
};

/*
 * Temporary mappings that will only exist for as long as some pages
 * are not editionized
 */

/*
 * For our editions rollout, we have special logic to ensure that edition redirects are followed
 * in SPA clicks. This does not work for some page types, because those pages don't have
 * an accurate url_full field.
 */
export const EDITION_SPA_REDIRECT_DISABLED_PAGE_TYPES = [
  ARCHIVES_PAGE_TYPE,
  CONTRIBUTOR_PAGE_TYPE,
  SEARCH_PAGE_TYPE,
  STATIC_PAGE_TYPE
];

/**
 * Google Ad Manager
 */
export const VICE_AD_NETWORK_ID = 16916245;

/*
 * Video handler timeouts for Video Series preview image hiding.
 *
 * Facebook's embed takes a little longer to load than YT or FB, so
 * we should show the preview image a little longer. A bug
 * report has been filed with Facebook here:
 * https://developers.facebook.com/support/bugs/1779920482074370/?disable_redirect=0
 */
export const FB_READY_HANDLER_TIMEOUT = 10000;
export const JW_READY_HANDLER_TIMEOUT = 6000;
export const YT_READY_HANDLER_TIMEOUT = 6000;

/* Dates */
export const DAY_RANGES = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
export const PUBLICATION_START_YEAR = {
  [EDITION_ID_EN_US]: 2005,
  [EDITION_ID_EN_GB]: 2012,
  [EDITION_ID_DE_DE]: 2012,
  [EDITION_ID_FR_FR]: 2019,
  [EDITION_ID_EN_CA]: 2018,
  [EDITION_ID_EN_AU]: 2020
};
export const TWENTY_FOUR_HOURS = 1000 * 60 * 60 * 24;
export const TIME_ZONE_UTC = 'UTC';

/* Categories that determine rules for multiple components */
export const BEAUTY_PRIMARY_CATEGORY = 'Beauty';
export const ENTERTAINMENT_PRIMARY_CATEGORY = 'Entertainment';
export const FASHION_PRIMARY_CATEGORY = 'Fashion';
export const FOOD_DRINKS_PRIMARY_CATEGORY = 'Food & Drinks';
export const GLOBAL_NEWS_PRIMARY_CATEGORY = 'Global News';
export const LIVING_PRIMARY_CATEGORY = 'Living';
export const POLITICS_PRIMARY_CATEGORY = 'Politics';
export const SHOPPING_PRIMARY_CATEGORY = 'Shopping';
export const US_NEWS_PRIMARY_CATEGORY = 'US News';
export const WELLNESS_PRIMARY_CATEGORY = 'Wellness';
export const SOLD_CONTENT_TYPES = {
  CUSTOM: 'CUSTOM',
  SPONSORED: 'SPONSORED',
  REAL_TIME_CONTENT: 'REAL_TIME_CONTENT'
};
export const SOLD_CONTENT_TYPE_VALUES = {
  [SOLD_CONTENT_TYPES.CUSTOM]: 'Custom',
  [SOLD_CONTENT_TYPES.SPONSORED]: 'Sponsored',
  [SOLD_CONTENT_TYPES.REAL_TIME_CONTENT]: 'Real-Time Content'
};

/* Categories IDs for Spot.im Recirulation */
export const SPOTIM_WORK_AND_MONEY_CATEGORY = 1028;
export const SPOTIM_ENTERTAINMENT_CATEGORY = 1059;
export const SPOTIM_STYLE_CATEGORY = 1001; // Fashion
export const SPOTIM_BEAUTY_CATEGORY = 1012;
export const SPOTIM_HEALTH_CATEGORY = [1051, 1017]; // Health, Wellness
export const SPOTIM_FOOD_CATEGORY = 1024;
export const SPOTIM_US_NEWS_PRIMARY_CATEGORY = 1065;

/* Channel tag slugs used for sticky button */
export const CHANNEL_TAG_SLUG_NEWS = 'news';
export const CHANNEL_TAG_SLUG_POLITICS = 'politics';

/* Channel tag slug for Super Sale */
export const CHANNEL_TAG_SLUG_SHOPPING = 'shopping';

/* Node and element attributes */
export const ARTICLE_MAIN_CONTENT_NODE_ID = 'article-main-content';
export const CONDENSED_HEADER = 'condensed-header';
export const EDITORIAL_CONTENT_NODE_ID = 'editorial-content';
export const CONTENT_CAPTION_ELEMENT_CLASS_NAME = 'content-caption';
export const PRODUCT_DESCRIPTION_ELEMENT_CLASS_NAME = 'product-description';
export const GLOBAL_HEADER_CLASS_NAME = 'global-header';

/*
 * Regex for R29-hosted images.
 * - If a string matches this, then it is a resizable image asset
 * - First capture group is the URL until the second capture group
 * - Second capture group grabs the hex checksum part of the url (e.g. "f4c")
 * - Third capture group is the URL from the second to the fourth capture group
 * - Fourth capture group is the "400x300,80" part of the URL
 * - Fifth capture group is the URL from the fourth to the sixth capture group
 * - Sixth capture group grabs the file extension
 */
export const R29_IMAGE_REGEX =
// (     1       )( 2 )(  3 )(  4   )(      5       )( 6 )
  /(^.+bin\/\w+\/)(\w+)(.*\/)([^/]*)(\/\d+\/[\w-]+\.)(\w+)/;

/*
 * Returns a match for URLs serving images via the /images/ path.
 * - 0th capture group is the whole tested string
 * - 1st capture group is the base domain
 * - 2nd capture group is the image ID
 * - 3rd capture group is the image extension/format
 * Ex: https://www.r29.co/images/1564672132605.jpg
 */
export const NEW_IMAGE_REGEX = /(.*)\/images\/(\d*).(\w*)/;

/*
 * We want all jpgs to load with a quality of 80. We can bump this up or down,
 * but we should profile bandwidth when we do so.
 *
 * Hero images should be slightly higher quality.
 */
export const JPG_QUALITY = 80;
export const JPG_QUALITY_HQ = 85;

export const DESKTOP_FULL_WIDTH_SLIDESHOW_CONTAINER_WIDTH_PX = 885;
export const DESKTOP_SLIDESHOW_CONTAINER_WIDTH_PX = 545;
export const MOBILE_SLIDESHOW_LAZY_LOAD_CUSHION_PX = 400;
export const NON_MOBILE_GRID_WIDTH_PX = 720;
export const FLOATING_IMAGE_MARGIN_PX = 20;
export const RESPONSIVE_IMG_WIDTH_PX = 245;
export const RESPONSIVE_IMG_HEIGHT_PX = 295;

export const BREAKPOINT_LARGE_PX = 1220;
export const BREAKPOINT_MEDIUM_PX = 760;

/* Vendor Keys and IDs */
export const PRODUCTION_FACEBOOK_APP_ID = 155023867867753;
export const DEVELOPMENT_FACEBOOK_APP_ID = 169015066448565;
export const NIELSEN_VIDEO_APP_NAME = 'r29-jw-player';
export const PRODUCTION_NIELSEN_STATIC_APP_ID = 'P995CCB88-ACE8-4F84-849E-EFB8D91F4982';
export const DEVELOPMENT_NIELSEN_STATIC_APP_ID = 'T09AC19E2-6B3F-423D-A8AA-EEA991CA6CA4';
export const PRODUCTION_NIELSEN_VIDEO_APP_ID = 'PFE4D7A18-4219-41A6-825B-87D9E7B7B18C';
export const DEVELOPMENT_NIELSEN_VIDEO_APP_ID = 'TFE4D7A18-4219-41A6-825B-87D9E7B7B18C';

/* Shopping List Pages */
export const SHOPPING_SORT_OPTIONS = [
  {
    name: 'newest',
    sort: null
  },
  {
    name: 'low > high',
    sort: 'price'
  },
  {
    name: 'high > low',
    sort: '-price'
  }
];
export const SHOPPING_PRICE_OPTIONS = [
  {
    name: 'Under $50',
    minPrice: '0',
    maxPrice: '4999'
  },
  {
    name: '$50 > $99',
    minPrice: '5000',
    maxPrice: '9999'
  },
  {
    name: '$100 > $249',
    minPrice: '10000',
    maxPrice: '24999'
  },
  {
    name: '$250 > $499',
    minPrice: '25000',
    maxPrice: '49999'
  },
  {
    name: '$500 > $999',
    minPrice: '50000',
    maxPrice: '99999'
  },
  {
    name: '$1000 AND ABOVE',
    minPrice: '100000'
  }
];

export const SHOPPING_CATEGORY_COLLECTIONS = 'collections';
export const SHOPPING_CATEGORY_COLLECTIONS_ID = 987;
export const SHOPPING_HOME_CATEGORY_ID = 916;


/*
 * Things set via PM2 env variables, with fallback for local development
 * if necessary
 */
export const ROSETTA_PORT = process.env.ROSETTA_PORT || 3001;
export const SENTRY_ADDRESS = process.env.SENTRY_ADDRESS;
export const SENTRY_ADDRESS_NODE = process.env.SENTRY_ADDRESS_NODE;


/* Slimcut */
export const SLIMCUT_CONTAINER_ID = 'div-gpt-ad-1494528017690-0';

/* Row types */
export const ROW_TYPE_FOUR_PRODUCTS = '4-product';
export const ROW_TYPE_FLEX_VIDEO = 'flex-video';
export const ROW_TYPE_FLEX_SERIES = 'flex-series';
export const ROW_TYPE_MULTI_STORY = 'multi-story';
export const ROW_TYPE_ONE_FEATURED_CARD = 'featured';
export const ROW_TYPE_ONE_FEATURED_STORY = '1-featured-story';
export const ROW_TYPE_ONE_STORY_HERO = '1-story-hero';
export const ROW_TYPE_ONE_PRIME_CARD = '1-prime';
export const ROW_TYPE_THREE_CHANNELS = '3-channel';
export const ROW_TYPE_THREE_PREMIUM_CARDS = '3-premium';
export const ROW_TYPE_THREE_PRIME_CARDS = '3-prime';
export const ROW_TYPE_THREE_STANDARD_CARDS = '3-standard';
export const ROW_TYPE_THREE_FEATURED_CARDS = '3-featured';
export const ROW_TYPE_TWO_STANDARD_CARDS = '2-standard';
export const ROW_TYPE_CTA_BAR = 'cta-bar';
export const ROW_TYPE_FOUR_VIDEO = '4-video';
export const ROW_TYPE_HTML = 'html';
export const ROW_TYPE_SHOPPING_HERO = 'shopping-hero';
export const ROW_TYPE_FEATURED_CATEGORY = 'featured-category';
export const ROW_TYPE_FLEX_CATEGORY = 'flex-category';
export const ROW_TYPE_TWO_CATEGORY = '2-category';
export const ROW_TYPE_MOST_POPULAR = 'most-popular';
export const ROW_TYPE_SUPER_SALE = 'super-sale';

/* Card types */
export const CARD_TYPE_CHANNEL = 'aggregation_page';
export const CARD_TYPE_PRODUCTS = 'shops_product';
export const CARD_TYPE_SERIES = 'blog_series';
export const CARD_TYPE_CTA_BUTTON = 'cta_button';
export const CARD_TYPE_HTML = 'html';
export const CARD_TYPE_SHOPS_CATEGORY = 'shops_category';
export const CARD_TYPE_POPULAR_ENTRY = 'popular_entry';
export const CARD_TYPE_SUPER_SALE = 'super_sale_product';

/* Module Types */
export const RELATED_CONTENT_MODULE = 'related-content';

/* Navigation Category Types */
export const NAVIGATION_CATEGORY_TYPE_DISCOVER = 'discover';
export const NAVIGATION_CATEGORY_TYPE_WATCH = 'watch';
export const NAVIGATION_CATEGORY_TYPE_SHOP = 'shop';
export const NAVIGATION_CATEGORY_TYPE_MORE = 'more';

/* A/B Consumer Experiments */
export const NINETY_DAYS_IN_S = 86400 * 90;
export const EXPERIMENT_COOKIE_NAME = 'R29_CEXP_V1';

export const COOKIE_HEADER_TEXT = {
  [EDITION_ID_EN_US]: 'Cookie Declaration',
  [EDITION_ID_EN_GB]: 'Cookie Declaration',
  [EDITION_ID_DE_DE]: 'Cookie Richtlinie',
  [EDITION_ID_FR_FR]: 'Gestion Des Cookies',
  [EDITION_ID_EN_CA]: 'Cookie Declaration'
};

export const TIMESTAMP_MULTIPLIER_MS = 1000;

export const ONE_PIXEL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

/**
 * API Paths
 *
 * Reminder that process.env.WORDPRESS_API_HOST will only be available on the server side, so this
 * constant is also only available on the server side. If you need to get WORDPRESS_API_HOST
 * on the client, then use `context.wordpressApiHost`.
 */
export const WORDPRESS_API_HOST = process.env.WORDPRESS_API_HOST || 'test-refinery29.pantheonsite.io';
export const WORDPRESS_API_BASE_PATH = '/wp-json/r29/v1/rosetta';
export const WORDPRESS_API_AJAX_PATH = '/wp-admin/admin-ajax.php';
export const WORDPRESS_API_EMAIL_SUBSCRIBE = 'email_subscribe';

/* Outbrain mapping for template widget ids */
export const ARTICLE_WIDGET_ID = 'AR_1';
export const FULL_WIDTH_WIDGET_ID = 'AR_2';
export const SLIDESHOW_WIDGET_ID = 'AR_3';

/* Relevant Super Sale types for context aware events */
export const SUPER_SALE_RIGHT_RAIL = 'right-rail';

export const HEADER_LINKS = {
  'en-us': {
    'R29': 'https://www.refinery29.com/en-us',
    'Unbothered': 'https://www.refinery29.com/en-us/unbothered',
    'Somos': 'https://www.refinery29.com/en-us/latine-somos',
  },
  'en-gb': {
    'R29': 'https://www.refinery29.com/en-gb',
    'Unbothered': 'https://www.refinery29.com/en-gb/unbothered-uk',
    'Somos': 'https://www.refinery29.com/en-us/latine-somos',
  },
  'de-de': {
    'R29': 'https://www.refinery29.com/de-de',
    'Unbothered': 'https://www.refinery29.com/en-us/unbothered',
    'Somos': 'https://www.refinery29.com/en-us/latine-somos',
  },
  'fr-fr': {
    'R29': 'https://www.refinery29.com/fr-fr',
    'Unbothered': 'https://www.refinery29.com/en-us/unbothered',
    'Somos': 'https://www.refinery29.com/en-us/latine-somos',
  },
  'en-au': {
    'R29': 'https://www.refinery29.com/en-au',
    'Unbothered': 'https://www.refinery29.com/en-us/unbothered',
    'Somos': 'https://www.refinery29.com/en-us/latine-somos',
  },
  'en-ca': {
    'R29': 'https://www.refinery29.com/en-us',
    'Unbothered': 'https://www.refinery29.com/en-us/unbothered',
    'Somos': 'https://www.refinery29.com/en-us/latine-somos',
  },
}
